/**
 * EmptyState — delightful, bee-mascot-driven empty states for Communities.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { MascotContainer, Button } from '@/components/site/primitives';
import { fadeUp } from '@/lib/motion';
import { EMPTY_STATE_MESSAGES } from './constants';

import beeStand from '@/assets/bee-stand.png';
import beeFly from '@/assets/bee-fly.png';
import beeScribble from '@/assets/bee-scribble.png';
import beeBack from '@/assets/bee-back.png';

const MASCOTS = {
  myCommunities: beeFly,
  discussions: beeScribble,
  events: beeStand,
  members: beeStand,
  notifications: beeBack,
  search: beeBack,
};

export default function EmptyState({ type = 'discussions', onCTAClick, size = 'md', heading, subheading, cta }) {
  const message = EMPTY_STATE_MESSAGES[type] ?? EMPTY_STATE_MESSAGES.discussions;
  const compact = size === 'sm';

  return (
    <div className={compact ? 'flex items-center justify-center py-10' : 'flex min-h-[320px] items-center justify-center py-10'}>
      <motion.div variants={fadeUp} initial="hidden" animate="show" className="mx-auto max-w-sm text-center">
        <MascotContainer src={MASCOTS[type] ?? beeStand} alt="" className={compact ? 'mx-auto h-20 w-20' : 'mx-auto h-28 w-28'} />
        <h2 className="mt-4 font-display text-lg font-semibold text-ink">{heading ?? message.heading}</h2>
        <p className="mt-2 text-sm leading-relaxed text-subtle">{subheading ?? message.subheading}</p>
        {onCTAClick && (cta ?? message.cta) && (
          <Button variant="primary" icon={false} onClick={onCTAClick} className="mt-5">
            {cta ?? message.cta}
          </Button>
        )}
      </motion.div>
    </div>
  );
}
